import React from "react";

function WhatIsDeFiLottery() {
  return (
    <div className="container p-5">
      <div
        className="pricing-style-one-item-cos bg-dark text-light"
        style={{
          backgroundImage:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
        }}
      >
        <div className="text-center">
          <h3>What is a DeFi Lottery Platform</h3>
          <div className="bottom">
            <div className="pricing">
              <p>
                A DeFi Lottery Platform is a decentralized application that
                operates on blockchain technology to facilitate lottery games
                without centralized control or intermediaries. Unlike
                traditional lotteries, which are managed by governments or
                private organizations, DeFi (decentralized finance) lottery
                platforms leverage smart contracts to create transparent,
                automated, and trustless lottery systems. These platforms aim to
                enhance fairness, security, and accessibility, providing users
                with more control and ownership over their participation and
                winnings.
              </p>
            </div>
            <a className="btn btn-style-one mt-30" href="#">
              Get Started
            </a>
          </div>
        </div>
        {/* <div className="right-info"></div> */}
      </div>
    </div>
  );
}

export default WhatIsDeFiLottery;
